var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 32,
    fill: "#C72E49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 48C84.24 48 48 84.24 48 128C48 171.76 84.24 208 128 208C171.76 208 208 171.76 208 128C208 84.24 171.76 48 128 48ZM128 188C95.28 188 68 160.72 68 128C68 95.28 95.28 68 128 68C160.72 68 188 95.28 188 128C188 160.72 160.72 188 128 188Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 88C106.36 88 88 106.36 88 128C88 149.64 106.36 168 128 168C149.64 168 168 149.64 168 128C168 106.36 149.64 88 128 88ZM128 148C117.4 148 108 138.6 108 128C108 117.4 117.4 108 128 108C138.6 108 148 117.4 148 128C148 138.6 138.6 148 128 148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinioLogo);
export default __webpack_public_path__ + "static/media/minioLogo.72f9ed6a6cd2aa424dc43bbd3e0c4782.svg";
export { ForwardRef as ReactComponent };